<!-- Header -->
<div class="header center header-boxed sticky-autohide header-two" [class.hide]="isHidden">
  <div class="container">
    <div class="header-logo">
      <h3 class="font-family-outfit uppercase letter-spacing-1">
        <a routerLink="/">Maximo</a>
      </h3>
    </div>

    <!-- Menu -->
    <div class="header-menu" [ngClass]="{ 'show': isMenuOpen }">
      <ul class="nav">
        <!-- Dropdown Item -->
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(0)">Home</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 0 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/">Creative Agency</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-two">Corporate Agency</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-three">Marketing Agency</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-four">Freelancer</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-five">Designer</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-six">Startup Agency</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 0 }" (click)="toggleDropdown(0)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(1)">Pages</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 1 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/about-us">About Us</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/our-team">Our Team</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/team-details">Team Details</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/testimonials">Testimonials</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/pricing-table">Pricing Table</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/404-page">404 Error Page</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/coming-soon">Coming Soon</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 1 }" (click)="toggleDropdown(1)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(2)">Services</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 2 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/services">Services</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 2 }" (click)="toggleDropdown(2)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(3)">Portfolio</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 3 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/portfolio-one">Portfolio One</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/portfolio-two">Portfolio Two</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/portfolio-three">Portfolio Three</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 3 }" (click)="toggleDropdown(3)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(4)">Blogs</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 4 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/blog-grid">Blog Grid</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/blog-standard">Blog Standard</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 4 }" (click)="toggleDropdown(4)"></a>
        </li>

        <li class="nav-item" (click)="closeMenu()">
          <a class="nav-link" routerLink="/contact">Contact Us</a>
        </li>
      </ul>
    </div>

    <!-- Social Icons -->
    <div class="header-menu-extra">
      <ul class="list-inline-sm">
        <li><a href="/" class="link-social-facebook"><i class="bi bi-facebook"></i></a></li>
        <li><a href="/" class="link-social-twitter"><i class="bi bi-twitter-x"></i></a></li>
        <li><a href="/" class="link-social-instagram"><i class="bi bi-instagram"></i></a></li>
      </ul>
    </div>

    <!-- Menu Toggle -->
    <button class="header-toggle" [class.toggle-close]="isMenuOpen" (click)="toggleMenu()">
      <span></span>
    </button>
  </div>
</div>
<!-- end Header -->

<!-- Hero section -->
<div class="bg-gradient-1 bg-fade-white-top">
  <div class="section-lg">
    <div class="container text-center">
      <div class="row">
        <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
          <h1 class="display-4 fw-normal text-dark line-height-120">We're Not Just Creative .We're Strategic.</h1>
          <ul class="list-inline mt-4">
            <li>
              <a class="button button-lg button-rounded button-font-2 button-gradient-1" routerLink="/about-us">About Us</a>
            </li>
            <li>
              <a class="button button-lg button-rounded button-font-2 button-white button-shadow button-hover-float" routerLink="/contact">Contact Us</a>
            </li>
          </ul>
        </div>
      </div><!-- end row -->
    </div><!-- end container -->
  </div>
</div>
<!-- end Hero section -->

<!-- Features section -->
<div>
  <div class="container icon-5xl">
    <div class="row g-4">
      <div *ngFor="let feature of features" class="col-12 col-lg-4 img-class">
        <div class="bg-white border-radius-1 box-shadow hover-float p-4 p-xl-5">
          <div class="text-gradient-1 mb-2 mb-lg-3">
            <i [class]="feature.icon"></i>
          </div>
          <h5 class="fw-medium">{{ feature.title }}</h5>
          <p>{{ feature.description }}</p>
        </div>
      </div>
    </div><!-- end row -->
  </div><!-- end container -->
</div>
<!-- end Features section -->

<!-- Portfolio section -->
<div class="section">
  <div class="container">
    <div class="mb-5">
      <div class="row text-center">
        <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
          <h2 class="display-6 fw-normal animate-text">We're Maximo Agency</h2>
          <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et
            magnis dis parturient montes, nascetur ridiculus mus.</p>
        </div>
      </div>
    </div>
  </div><!-- end container -->
  <div class="container-fluid px-4">
    <div class="row gallery-wrapper g-4 border-radius">
      <div *ngFor="let item of galleryItems; let i = index" class="col-12 col-md-6 col-lg-4 gallery-box img-class">
        <div class="gallery-img" (click)="openGallery(i)" style="cursor: pointer;">
          <img [src]="item.src" [alt]="item.title" style="width: 100%; height: 100%; object-fit: cover;">
        </div>
      </div>
    </div><!-- end row -->
  </div><!-- end container-fluid -->

<!-- Custom Lightbox Modal -->
<div *ngIf="showGalleryModal" class="gallery-modal" style="display: flex;" (click)="closeGallery()">
  <div class="gallery-modal-content" (click)="$event.stopPropagation()">
    <div class="gallery-modal-header">
      <button (click)="closeGallery()" class="gallery-modal-close">&times;</button>
    </div>
    <div class="gallery-modal-body">
      <img [src]="galleryItems[currentGalleryIndex].src" [alt]="galleryItems[currentGalleryIndex].title">
      <div class="gallery-modal-nav">
        <button (click)="previousGalleryImage()" class="gallery-nav-btn gallery-nav-prev">
          <i class="bi bi-chevron-left"></i>
        </button>
        <span class="gallery-counter">{{ currentGalleryIndex + 1 }} / {{ galleryItems.length }}</span>
        <button (click)="nextGalleryImage()" class="gallery-nav-btn gallery-nav-next">
          <i class="bi bi-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</div><!-- end Custom Lightbox Modal -->

<!-- About Gallery Lightbox Modal -->
<div *ngIf="showAboutGalleryModal" class="gallery-modal" style="display: flex;" (click)="closeAboutGallery()">
  <div class="gallery-modal-content" (click)="$event.stopPropagation()">
    <div class="gallery-modal-header">
      <button (click)="closeAboutGallery()" class="gallery-modal-close">&times;</button>
    </div>
    <div class="gallery-modal-body">
      <img [src]="aboutGalleryItems[currentAboutGalleryIndex].src" [alt]="aboutGalleryItems[currentAboutGalleryIndex].title">
      <div class="gallery-modal-nav">
        <button (click)="previousAboutGalleryImage()" class="gallery-nav-btn gallery-nav-prev">
          <i class="bi bi-chevron-left"></i>
        </button>
        <span class="gallery-counter">{{ currentAboutGalleryIndex + 1 }} / {{ aboutGalleryItems.length }}</span>
        <button (click)="nextAboutGalleryImage()" class="gallery-nav-btn gallery-nav-next">
          <i class="bi bi-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</div><!-- end About Gallery Lightbox Modal -->
</div>
<!-- end Portfolio section -->

<!-- Sliding Text -->
<section class="section-sm pt-0">
    <div class="sliding-text pb-3">
        <div class="container-fluid pd-0 overflow-hidden">
            <div class="row">
            <div class="col-12">
                <h2 class="display-1 fw-semi-bold mb-0 opacity-1 text-gradient-1 font-family-philosopher font-italic text-capitalize animate-left">Top Selling HTML Template. Maximo Multipurpose Template.</h2>
            </div>
            </div>
        </div>
    </div>
</section>
<!-- end Sliding Text -->

<!-- Parallax section -->
<div class="section-2xl bg-image parallax" style="background-image: url('assets/images/backgrounds/video-bg-3.jpg')">
    <div class="bg-dark-03">
        <div class="container text-center">
            <a class="button-circle button-circle-xl button-circle-white-2 button-circle-ripple icon-xl button-hover-shrink lightbox-media-link" (click)="openPopup()">
                <i class="bi bi-play"></i>
            </a>
        </div><!-- end container -->
    </div>
</div>
<!-- end Parallax section -->

<!-- Video Popup -->
<div class="video-popup" *ngIf="isOpen">
    <div class="popup-inner">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/CygqGDPoZWQ?si=0GVlvXAPieQYM4RY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <button (click)="closePopup()" type="button" class="close-btn">
            <i class='bi bi-x'></i>
        </button>
    </div>
</div>

<!-- About section -->
<div class="section">
  <div class="container">
    <div class="row g-5 align-items-center">
      <div class="col-12 col-lg-6">
        <div class="row gallery-wrapper g-3">
          <div *ngFor="let item of aboutGalleryItems; let i = index" class="col-6 gallery-box img-class">
            <div class="gallery-img border-radius" (click)="openAboutGallery(i)" style="cursor: pointer;">
              <img [src]="item.src" [alt]="item.title" style="width: 100%; height: 100%; object-fit: cover;">
            </div>
          </div>
        </div><!-- end gallery-wrapper -->
      </div>
      <div class="col-12 col-lg-6">
        <div class="d-inline-block bg-light-turquoise px-3 py-2 border-radius-2 mb-3">
          <span class="font-small fw-medium uppercase line-height-100 text-gradient-1">Inspiring People</span>
        </div>
        <h3 class="fw-normal">We believe that great things in business are never done by one person. They're done by a team of people.</h3>
        <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p>
      </div>
    </div><!-- end row -->
  </div><!-- end container -->
</div>
<!-- end About section -->

<!-- Prices section -->
<div class="bg-gray-lighter bg-fade-white-top">
  <div class="section">
    <div class="container">
      <div class="mb-5">
        <div class="row text-center">
          <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
            <h2 class="display-6 font-family-outfit fw-normal animate-text">Pricing Table</h2>
            <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Integer tincidunt.</p>
          </div>
        </div>
      </div>
      <div class="row g-4 mt-5 text-center">
        <div *ngFor="let plan of pricingPlans" class="col-12 col-md-4 img-class">
          <div class="bg-white box-shadow hover-float border-radius p-4" [ngClass]="{ 'mt-lg-4': plan.id !== 2 }">
            <h6 class="font-small fw-medium uppercase letter-spacing-1">{{ plan.name }}</h6>
            <div class="mt-3">
              <h1 class="line-height-100 fw-medium mb-0 text-color-theme">{{ plan.price }}</h1>
              <span>monthly</span>
            </div>
            <ul class="list-unstyled mt-4">
              <li *ngFor="let feature of plan.features">{{ feature }}</li>
            </ul>
            <a class="button button-md button-gradient-1 button-rounded mt-4" routerLink="/pricing-table">Choose Plan</a>
          </div>
        </div>
      </div><!-- end row -->
    </div><!-- end container -->
  </div>
</div>
<!-- end Prices section -->

<!-- Testimonial section -->
<div class="section">
    <div class="container">
        <owl-carousel-o [options]="customOptions" class="owl-btn-center-lr testimonial-inner mrt-80">
          <ng-template carouselSlide *ngFor="let slide of slideStore">
            <!-- Testimonial box -->
            <div class="testimonial-box">
              <img class="mb-3" src="assets/images/testimonials/{{slide.image}}" alt="client-img">
              <h5 class="fw-normal line-height-140 m-0">{{slide.title}}</h5>
              <span class="font-small fw-normal">{{slide.subtitle}}</span>
              <p class="mt-3">{{slide.desc}}</p>
            </div>
          </ng-template>
        </owl-carousel-o>
    </div>
</div><!-- end container -->
<!-- end Testimonial section -->

<!-- Contact section -->
<div class="section">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3 text-center">
                <h6 class="d-inline-block bg-gray border-radius px-3 py-2 line-height-140 font-small uppercase letter-spacing-1 mb-3"><span class="text-gradient-1">Get in Touch</span></h6>
                <h2 class="fw-semi-bold mb-0 text-capitalize">Elevating Brands with Timeless Design.</h2>
            </div>
        </div><!-- end row -->
        <div class="row g-4 mt-4">
            <div class="col-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 text-center">
                <div class="contact-form text-start">
                    <form (submit)="sendEmail($event)" #contactForm="ngForm">
                        <div class="row gx-3 gy-0">
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <label class="visually-hidden" for="user_name">Name</label>
                                    <input class="border-radius" type="text" minlength="2" maxlength="15" [class.is-invalid]="userName.invalid && userName.touched"
                                        name="user_name" id="name" placeholder="Name *" [(ngModel)]="formData.user_name" #userName="ngModel" required>
                                    <div *ngIf="userName.invalid && userName.touched" class="invalid-feedback mrb-10">
                                        Name is required.
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <input type="email" minlength="2" maxlength="35" [class.is-invalid]="userEmail.invalid && userEmail.touched"
                                        name="user_email" class="md-input border-radius" id="email" placeholder="Email *" [(ngModel)]="formData.user_email"
                                        #userEmail="ngModel" required email>
                                    <div *ngIf="userEmail.invalid && userEmail.touched" class="invalid-feedback mrb-10">
                                        A valid email is required.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="visually-hidden" for="message">Project Details</label>
                            <textarea name="message" [class.is-invalid]="userMessage.invalid && userMessage.touched" class="md-textarea border-radius"
                                id="message" rows="7" placeholder="Project Details" [(ngModel)]="formData.message" #userMessage="ngModel"
                                required></textarea>
                            <div *ngIf="userMessage.invalid && userMessage.touched" class="invalid-feedback mb-10">
                                Project details are required.
                            </div>
                        </div>
                        <button class="button button-lg button-rounded button-font-2 button-gradient-1" type="submit" name="submit" [disabled]="contactForm.invalid" value="Send Message">Send Message</button>
                    </form>
                </div>
            </div>
        </div><!-- end row -->
    </div><!-- end container -->
</div>
<!-- end Contact section -->